const LOGIN_RETURN_KEY = "unma_login_return_to";

export const isDefaultLoginReturn = (value) => {
  if (value == null) return true;
  const raw = String(value).trim();
  if (!raw || raw === "/" || raw === "/login") return true;
  try {
    const url = new URL(raw, "https://www.unmaapp.com");
    return url.pathname === "/" || url.pathname === "/login";
  } catch {
    return raw === "/";
  }
};

export const storeLoginReturnTo = (returnTo) => {
  if (typeof sessionStorage === "undefined") return;
  if (isDefaultLoginReturn(returnTo)) {
    sessionStorage.removeItem(LOGIN_RETURN_KEY);
    return;
  }
  sessionStorage.setItem(LOGIN_RETURN_KEY, String(returnTo));
};

export const peekLoginReturnTo = () => {
  if (typeof sessionStorage === "undefined") return "/";
  const value = sessionStorage.getItem(LOGIN_RETURN_KEY);
  return isDefaultLoginReturn(value) ? "/" : value;
};

export const consumeLoginReturnTo = () => {
  const value = peekLoginReturnTo();
  if (typeof sessionStorage !== "undefined") {
    sessionStorage.removeItem(LOGIN_RETURN_KEY);
  }
  return value;
};

export const resolveLoginReturnTo = (queryRedirect) => {
  if (!isDefaultLoginReturn(queryRedirect)) {
    storeLoginReturnTo(queryRedirect);
    return queryRedirect;
  }
  return peekLoginReturnTo();
};

export const loginPath = (returnTo) => {
  storeLoginReturnTo(returnTo);
  return "/login";
};
